import {
    Box, SimpleGrid, Card, CardBody, Image, Text, Flex, Spinner, useToast,
    Stack,
    Heading,
    Button,
    CardFooter,
    Grid,
    Textarea,
    AlertDialog,
    AlertDialogOverlay,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogBody,
    AlertDialogFooter,
    Badge,
    Input
} from '@chakra-ui/react';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import axiosClient from '../../../axios-client';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd';
import empty from '../../../assets/images/emptyupdate.png'
import content from '../../../assets/images/content.png'

export default function GestHighlightedContent() {
    const [highlighted, setHighlighted] = useState([]);
    const [loading, setLoading] = useState(true);
    const toast = useToast();
    const navigate = useNavigate()
    const { t } = useTranslation()
    const [isAlertOpen, setIsAlertOpen] = useState(false);

    const [editingId, setEditingId] = useState(null);
    const [editedText, setEditedText] = useState('');

    const [deleteId, setDeleteId] = useState(null);
    const cancelRef = React.useRef()

    const [showFullText, setShowFullText] = useState(false);
    const [editedTag, setEditedTag] = useState("");


    const onOpenAlert = () => {
        setIsAlertOpen(true);
    };
    const onCloseAlert = () => {
        setIsAlertOpen(false);
    };
    useEffect(() => {
        async function fetchHighlights() {
            try {
                const { data } = await axiosClient.get('highlighted-content/');
                setHighlighted(data);
            } catch (error) {
                toast({
                    title: "Erreur lors du chargement",
                    description: "Impossible de charger le contenu mis en avant.",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "bottom-right"
                });
            } finally {
                setLoading(false);
            }
        }
        fetchHighlights();
    }, []);

    if (loading) {
        return (
            <Flex justify="center" align="center" height="100vh">
                <Spinner size="xl" />
            </Flex>
        );
    }

    // if (highlighted.length === 0) {
    //   return <Text textAlign="center" mt={10}>Aucun contenu mis en avant trouvé.</Text>;
    // }
    const handleOnDragEnd = (result) => {
        if (!result.destination) return;

        // Reorder the items
        const reorderedItems = Array.from(highlighted);
        const [movedItem] = reorderedItems.splice(result.source.index, 1);
        reorderedItems.splice(result.destination.index, 0, movedItem);

        setHighlighted(reorderedItems);

        // Update the database with the new order
        updateDatabase(reorderedItems);
    };

    const updateDatabase = (newOrder) => {
        const updatedOrder = newOrder.map((item, index) => ({
            id: item.id,
            order: index,
        }));

        axiosClient.post('/highlighted-content/update_order/', updatedOrder)
            .then(response => {
                // console.log("Order updated successfully:", response.data);
            })
            .catch(error => {
                // console.error("Error updating order:", error);
            });
    };

    const handleSave = async (id) => {
        try {
            const response = await axiosClient.put(`/highlighted-content/update/${id}/`, {
                text: editedText,
                tag :editedTag,
            });

            setHighlighted(prev =>
                prev.map(item =>
                    item.id === id ? { ...item, text: editedText ,tag:editedTag} : item
                )
            );

            setEditingId(null);
            toast({
                description: "Texte mis à jour avec succès.",
                status: "success",
                duration: 3000,
                variant: 'left-accent',
                isClosable: true,
                position: "bottom-right"
            });
        } catch (error) {
            console.log(error);

            toast({
                description: "La mise à jour du texte a échoué.",
                status: "error",
                variant: 'left-accent',
                duration: 3000,
                isClosable: true,
                position: "bottom-right"
            });
        }
    };
    const handleDelete = (id = deleteId) => {
        if (!id) return;
        axiosClient.delete(`/highlighted-content/delete/${id}/`)
            .then((response) => {
                setHighlighted((prevData) => prevData.filter((row) => row.id !== id));
                toast({
                    description: t("Le contenu est supprimé de la surbrillance avec succès"),
                    status: 'success',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                })
            })
            .catch((error) => {
                // console.error(error);
            });
        onCloseAlert()
    }
    return (
        <Box>

            <Flex>
                <Box w="100%" display={"flex"} justifyContent="space-between" flexDirection={{ base: 'column', md: "row" }} mt={2} mb={{ base: 0, md: 5 }}>
                    <Text fontFamily='Plus Jakarta Display' as="cite" fontSize={{ base: "18px", md: "20px", lg: "25px" }} color="gray"><span onClick={() => navigate('/')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t("Accueil")}</span>  / <span>{t("Contenu en highlight")}</span> </Text>

                </Box>

            </Flex>
            <Flex direction='column' mt={{ sm: '25px', md: '0px' }} p={{ base: 0, lg: 2 }}>
                {highlighted.length > 0 ?
                    <Grid templateColumns={{ sm: "1fr", md: "1fr", lg: "2fr 1fr " }} justify={"center"} gap='22px'>
                        <DragDropContext onDragEnd={handleOnDragEnd}>
                            <Droppable droppableId="droppable">
                                {(provided) => (
                                    <Box ref={provided.innerRef} {...provided.droppableProps} mt={2} display="flex" flexDirection="column" gap={5}>
                                        {highlighted.map((highlight, index) => {
                                            const content = highlight.contentInfo;

                                            return (
                                                <Draggable key={highlight.id} draggableId={highlight.id.toString()} index={index}>
                                                    {(provided) => (
                                                        <Card
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            key={index}
                                                            direction={{ base: 'column', sm: 'row' }}
                                                            overflow='hidden'
                                                            variant='outline'
                                                            w={"auto"}
                                                        >
                                                            <Image
                                                                objectFit='cover'
                                                                maxW={{ base: '100%', sm: '200px' }}
                                                                src={content.image_Hquality || content.image}
                                                                alt='Media'
                                                            />

                                                            <Stack w={"100%"}>
                                                                <CardBody >
                                                                    <Heading size='md'>{content.title} <Badge borderRadius={"md"} colorScheme='orange'>{content.type}</Badge></Heading>
                                                                    {editingId === highlight.id ? (
                                                                        <Input
                                                                            mt={2}
                                                                            py='2'
                                                                            placeholder="Tag (ex: 🔥 Exclusif, 🕑 Disponible...)"
                                                                            value={editedTag}
                                                                            onChange={(e) => setEditedTag(e.target.value)}
                                                                        />
                                                                    ) : (
                                                                        highlight.tag && (
                                                                            <Badge mt={2} borderRadius="md" colorScheme="purple">
                                                                                {highlight.tag}
                                                                            </Badge>
                                                                        )
                                                                    )}
                                                                    {editingId === highlight.id ? (
                                                                        <Textarea
                                                                            mt={2}
                                                                            py='2'
                                                                            value={editedText}
                                                                            onChange={(e) => setEditedText(e.target.value)}
                                                                        />
                                                                    ) : (
                                                                        <Text py='2'>
                                                                            {highlight.text.length > 100 && !showFullText
                                                                                ? `${highlight.text.substring(0, 100)}...`
                                                                                : highlight.text}
                                                                            {highlight.text.length > 100 && (
                                                                                <Button
                                                                                    variant="link"
                                                                                    colorScheme="blue"
                                                                                    ml={2}
                                                                                    size="sm"
                                                                                    onClick={() => setShowFullText(!showFullText)}
                                                                                >
                                                                                    {showFullText ? 'Voir moins' : 'Voir plus'}
                                                                                </Button>
                                                                            )}
                                                                        </Text>
                                                                    )}

                                                                </CardBody>

                                                                <CardFooter pt={0} gap={2} display={"flex"} alignItems={"end"} w={"100%"} justifyContent={"end"}>
                                                                    {editingId === highlight.id ? (
                                                                        <>
                                                                            <Button
                                                                                variant='solid'
                                                                                colorScheme='green'
                                                                                onClick={() => handleSave(highlight.id)}
                                                                            >
                                                                                Enregistrer
                                                                            </Button>
                                                                            <Button
                                                                                variant='outline'
                                                                                onClick={() => setEditingId(null)}
                                                                            >
                                                                                Annuler
                                                                            </Button>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <Button
                                                                                variant='outline'
                                                                                colorScheme='green'
                                                                                onClick={() => {
                                                                                    setEditingId(highlight.id);
                                                                                    setEditedText(highlight.text);
                                                                                    setEditedTag(highlight.tag);
                                                                                }}
                                                                            >
                                                                                Modifier
                                                                            </Button>
                                                                            <Button onClick={() => {
                                                                                setDeleteId(highlight.id);
                                                                                onOpenAlert();

                                                                            }} variant='outline' colorScheme='red'>
                                                                                <Text display={{ base: 'none', lg: 'inline' }}>
                                                                                    Supprimer de la surbrillance
                                                                                </Text>
                                                                                <Text display={{ base: 'inline', lg: 'none' }}>
                                                                                    Supprimer
                                                                                </Text>
                                                                            </Button>
                                                                        </>
                                                                    )}
                                                                </CardFooter>
                                                            </Stack>
                                                        </Card>

                                                    )}
                                                </Draggable>
                                            );
                                        })}

                                    </Box>
                                )}
                            </Droppable>
                        </DragDropContext>
                        <Flex display={{ base: "none", lg: "flex" }} justify={"center"} align={'center'}>
                            <Image opacity={0.8} src={content} style={{ height: "250px", width: "250px", objectFit: 'contain' }} />
                        </Flex>
                    </Grid>
                    :
                    <Flex mb={'10'} mt={20} gap={2} flexDirection={'column'} h={"100%"} w={"100%"} alignItems={"center"} justifyContent={"center"}>
                        <Text color={'gray.500'} fontWeight={"semibold"}>{t("Aucun contenu mis en avant pour le moment.")}</Text>
                        <Image opacity={0.4} w={{ base: "150px", md: "200px", lg: "200px" }} src={empty} />
                    </Flex>
                }

            </Flex>
            <AlertDialog
                closeOnOverlayClick={false}
                isOpen={isAlertOpen}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlert}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t('Supprimer')}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            <Text>
                                {t('êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement.')}
                            </Text>
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button size={"sm"} ref={cancelRef} onClick={() => {
                                onCloseAlert()
                            }}>
                                {t('Annuler')}
                            </Button>
                            <Button size={"sm"} onClick={() => handleDelete(deleteId)} colorScheme='red' ml={3}>
                                {t('Supprimer')}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </Box>
    );
}
